/**
 * Interface padrão 
 */
export interface IVariable {
    index: number
    label: string
    value: string
}
/**
 * Interface para redux action 
 */
export interface IVariableAction {
    type: string
    payload: any
}
/**
 * Interface para objeto reducer
 */
export interface IVariableReducer {
    variablesList: VariableList
    variablesListContributingFactor: VariableList
    variablesListIncidentType: VariableList
    variablesListDamageLevel: VariableList
    variablesListNotificationType: VariableList
    variablesListNotificationTurn: VariableList
    variablesListPacientDocumentType: VariableList
    variablesListPacientGender: VariableList
    variablesListOmsClassification: VariableList
    loading: boolean
    error: boolean
}
/**
 * Interface usada no Axios para retorno lista de setores paginado
 */
export interface IResultVariableGetAll {
    result: VariableList
}
/**
 * Tipo para redux action 
 */
export type VariableAction = IVariableAction
/**
 * Tipo para lista padrão
 */
export type VariableList = IVariable[]
/**
 * Tipo para reducer
 */
export type VariableReducer = IVariableReducer
/**
 * Tipo padrão para variable
 */
export type Variable = IVariable
/**
 * Tipo usado no Axios para retorno lista de variaveis
 */
export type ResultVariableGetAll = IResultVariableGetAll
/**
 * Objeto padrão
 */
export const VariableReducerTypeInitiator:IVariableReducer = {
    variablesList: [],
    variablesListContributingFactor: [],
    variablesListIncidentType: [],
    variablesListDamageLevel: [],
    variablesListNotificationType: [],
    variablesListNotificationTurn: [],
    variablesListPacientDocumentType: [],
    variablesListPacientGender: [],
    variablesListOmsClassification: [],
    loading : true,
    error: false,
}
